import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  product: {
    noImageSrc:
      'https://cdn.shopify.com/s/files/1/0671/6801/0532/files/autohousesupplylogo_shopify_placed_holder_430x.png',
  },
};
